import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
	namespaced: true,
	state: {
		ApiStatus: 0,
		ApiWaitingStatus: false,
		now: 0,
		BrandList: [],
		ActiveBrandList: [],
		PrefList: [],
		InputPref: '',
		InputBrand: null,
		InputDate: [],
		InputCalPage: 0,
		InputCalTime: '',
		InputCalCol: 0,
		InputCustInfo: {
			FamilyName: '',
			GivenName: '',
			FamilyNameKana: '',
			GivenNameKana: '',
			BirthY: '',
			BirthM: '',
			BirthD: '',
			Tel: '',
			Email: '',
			Policy: ''
		},
		IsChild: false,
		CalPage: 0,
		CurrentSchedule: {
			ym: [],
			month: [],
			mday: [],
			j_weekday: [],
			bg_type: [],
			reservation_time: {}
		},
		NowDate: null,
		CalFirstDate: {
			y: (new Date()).getFullYear(),
			m: (new Date()).getMonth() + 1,
			d: (new Date()).getDate(),
		},
		token: '',
		validation: {
			area_s: true,
			area_m: '',
			store_s: true,
			store_m: '',
			date_s: true,
			date_m: '',
			FamilyName_s: true,
			FamilyName_m: '',
			GivenName_s: true,
			GivenName_m: '',
			FamilyNameKana_s: true,
			FamilyNameKana_m: '',
			GivenNameKana_s: true,
			GivenNameKana_m: '',
			BirthY_s: true,
			BirthY_m: '',
			BirthM_s: true,
			BirthM_m: '',
			BirthD_s: true,
			BirthD_m: '',
			Birthday_m: '',
			Tel_s: true,
			Tel_m: '',
			Email_s: true,
			Email_m: '',
			Policy_s: true,
			Policy_m: ''
		},
		reservation_no: 0,
                recent_public_form_tel_count: 0,
                service_name: '',
		web_id: 0
	},
	getters: {
		ApiWaitingStatus: state => state.ApiWaitingStatus,
		PrefList: state => state.PrefList,
		InputPref: state => state.InputPref,
		BrandList: state => state.BrandList,
		ActiveBrandList: state => state.BrandList.filter(brand => brand.pref_name === state.InputPref),
		InputBrand: state => state.InputBrand,
		CalPage: state => state.CalPage,
		CurrentSchedule: state => state.CurrentSchedule,
		NowDate: state => state.NowDate,
		CalFirstDate: state => state.CalFirstDate,
		InputDate: state => state.InputDate,
		InputCalPage: state => state.InputCalPage,
		InputCalTime: state => state.InputCalTime,
		InputCalCol: state => state.InputCalCol,
		InputCustInfo: state => state.InputCustInfo,
		IsChild: state => state.IsChild,
		now: state => state.now,
		token: state => state.token,
		validation: state => state.validation,
		reservation_no: state => state.reservation_no,
		recent_public_form_tel_count: state => state.recent_public_form_tel_count,
		service_name: state => state.service_name,
		web_id: state => state.web_id
	},
	methods: {
		getScheduleJson: async function() {
			let api_path = '../api/v1/schedule/' + state.InputBrand.store_sfid + '/'
			// let api_path = 'https://form.la-coco.com/api/v1/schedule/' + state.InputBrand.store_sfid + '/'

			try {
				return await axios.get(api_path).data
			} catch (error) {
				//console.log(error)
			}
		}
	},
	mutations: {
		setShopInfo(state, payload) {
			state.ApiStatus = Number(payload._status)
			state.now = Date.parse(payload._time)
			state.PrefList = payload._data_other.pref_list
			state.BrandList = payload._data

		},
		updateActiveBrandList(state, payload) {},
		setPrefList(state, payload) { state.PrefList = payload },
		setInputPref(state, payload) { state.InputPref = payload },
		setBrandList(state, payload) { state.BrandList = payload },
		setInputBrand(state, payload) { state.InputBrand = payload },
		async updateCalDate(state, payload) {
			let api_path = '../api/v1/schedule/' + state.InputBrand.store_sfid + '/'
			// let api_path = 'https://form.la-coco.com/api/v1/schedule/' + state.InputBrand.store_sfid + '/'
			if (state.CalPage !== 0 && state.CurrentSchedule.mday.length > 0) {
				let dt = new Date(state.CalFirstDate['y'],
									state.CalFirstDate['m'] - 1,
									state.CalFirstDate['d'],
									0, 0, 0)
				dt.setDate(dt.getDate() + 7 * state.CalPage)
				api_path += dt.getFullYear() * 10000
							+ (dt.getMonth() + 1) * 100
							+ dt.getDate()
			}
			// if (state.web_id !== 0) api_path += '/ambiguous'
			console.log( "state.web_id=" + state.web_id )
			if (state.web_id !== 0)  {
				api_path += '?service_id='
				api_path += state.web_id
			}
			console.log( "api_path=" + api_path )

			try {
				state.ApiWaitingStatus = true // Api通信中に任意の機能を無効にするために使う

				const json = (await axios.get(api_path)).data
				state.ApiStatus = Number(json._status)
				state.now = Date.parse(json._time)
				state.CurrentSchedule = {
					ym: [],
					month: [],
					mday: [],
					j_weekday: [],
					bg_type: [],
					reservation_time: {}
				}
				Object.keys(json._data[0].reservation_time).forEach(key => {
					state.CurrentSchedule.reservation_time[key] = []
				})
				json._data.forEach(d => {
					state.CurrentSchedule.ym.push([d.year, d.month])
					if (state.CurrentSchedule.month.indexOf(d.month) === -1)
						state.CurrentSchedule.month.push(d.month)
					state.CurrentSchedule.mday.push(d.mday)
					state.CurrentSchedule.j_weekday.push(d.j_weekday)
					switch (true) {
						case d.closed_flag === 1:
							state.CurrentSchedule.bg_type.push('closed')
							break;
						case d.holiday_flag === 1:
						case d.weekday === 0:
							state.CurrentSchedule.bg_type.push('holiday')
							break;
						case d.weekday === 6:
							state.CurrentSchedule.bg_type.push('saturday')
							break;
						default:
							state.CurrentSchedule.bg_type.push('weekday')
					}
					Object.keys(d.reservation_time).forEach(key => {
						state.CurrentSchedule.reservation_time[key].push(d.reservation_time[key])
					})

					if (state.CalPage === 0) {
						state.CalFirstDate['y'] = json._data[0].year
						state.CalFirstDate['m'] = json._data[0].month
						state.CalFirstDate['d'] = json._data[0].mday
					}
				})

				state.ApiWaitingStatus = false // ロックを解除
			} catch (error) {
				//console.log(error)
			}
		},
		updateCalPage(state, payload) { state.CalPage = payload },
		setInputDate(state, payload) {
			if (payload.status === true) {
				state.InputDate = [
					state.CurrentSchedule.ym[payload.col][0],
					state.CurrentSchedule.ym[payload.col][1],
					state.CurrentSchedule.mday[payload.col],
					state.CurrentSchedule.j_weekday[payload.col],
				]
				state.InputCalPage = state.CalPage
				state.InputCalTime = payload.time
				state.InputCalCol = payload.col
			} else {
				state.InputDate = []
				state.InputCalPage = 0
				state.InputCalTime = ''
				state.InputCalCol = 0
			}
		},
		setInputCustInfo(state, payload) {
			state.InputCustInfo[payload.type] = payload.val
		},
		setInputCustBirthday(state, payload) {
			state.InputCustInfo[payload.type] = payload.val

			if (state.InputCustInfo.BirthY !== ''
					&& state.InputCustInfo.BirthM !== ''
					&& state.InputCustInfo.BirthD !== '') {
				state.IsChild = Math.floor(((state.InputDate[0] * 10000
						+ state.InputDate[1] * 100
						+ state.InputDate[2] * 1)
						- (state.InputCustInfo.BirthY * 10000
						+ state.InputCustInfo.BirthM * 100
						+ state.InputCustInfo.BirthD * 1)
						) / 10000) < 18
			}
		},
		setIsChild(state, payload) { state.IsChild = Math.floor(((state.InputDate[0] * 10000
						+ state.InputDate[1] * 100
						+ state.InputDate[2] * 1)
						- (state.InputCustInfo.BirthY * 10000
						+ state.InputCustInfo.BirthM * 100
						+ state.InputCustInfo.BirthD * 1)
						) / 10000) < 18 },
		setToken(state, payload) { state.token = payload },
		setValidation(state, payload) { state.validation[payload.type] = payload.val },
		setReservationNo(state, payload) { state.reservation_no = payload },
		setRecentPublicFormTelCount(state, payload) { state.recent_public_form_tel_count = payload },
		setServiceName(state, payload) { state.service_name = payload },
		setWebId(state, payload) { state.web_id = payload },
		allClear(state, payload) {
			state.ApiStatus = 0
			state.now = 0
			state.BrandList = []
			state.ActiveBrandList = []
			state.PrefList = []
			state.InputPref = ''
			state.InputBrand = null
			state.InputDate = []
			state.InputCalPage = 0
			state.InputCalTime = ''
			state.InputCalCol = 0
			state.InputCustInfo = {
					FamilyName: '',
					GivenName: '',
					FamilyNameKana: '',
					GivenNameKana: '',
					BirthY: '',
					BirthM: '',
					BirthD: '',
					Tel: '',
					Email: '',
					Policy: ''
					}
			state.IsChild = false
			state.CalPage = 0
			state.CurrentSchedule = {
					ym: [],
					month: [],
					mday: [],
					j_weekday: [],
					bg_type: [],
					reservation_time: {}
					}
			state.NowDate = null
			state.CalFirstDate = {
					y: 0,
					m: 0,
					d: 0
					}
			state.token = ''
			state.validation = {
					area_s: true,
					area_m: '',
					store_s: true,
					store_m: '',
					date_s: true,
					date_m: '',
					FamilyName_s: true,
					FamilyName_m: '',
					GivenName_s: true,
					GivenName_m: '',
					FamilyNameKana_s: true,
					FamilyNameKana_m: '',
					GivenNameKana_s: true,
					GivenNameKana_m: '',
					BirthY_s: true,
					BirthY_m: '',
					BirthM_s: true,
					BirthM_m: '',
					BirthD_s: true,
					BirthD_m: '',
					Birthday_m: '',
					Tel_s: true,
					Tel_m: '',
					Email_s: true,
					Email_m: '',
					Policy_s: true,
					Policy_m: ''
					}
			state.reservation_no = 0
			state.recent_public_form_tel_count = 0
			state.service_name = ''
			state.web_id = 0
		}
	}
})



// WEBPACK FOOTER //
// ./src/store.js